import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider } from '@mui/material';
import Preloader from 'src/components/Preloader';
import ContractConfirmationDialog from 'src/views/contract/contracts/ContractToDigitalSignForm/CurrentStep/FinalStep/ContractConfirmationDialog';
import useStyles from '../styles';
import ReviewData from './ReviewData';

const FinalStep = ({
  data,
  includeEquipmentStep,
  handleSubmit,
  handleBack,
  loading
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const content = useMemo(() => {
    return !loading ? (
      <ReviewData values={data} includeEquipmentStep={includeEquipmentStep} />
    ) : (
      <Preloader />
    );
  }, [loading, includeEquipmentStep, data]);

  const handleOtherSubmit = e => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <FadeIn>
      <form onSubmit={handleOtherSubmit}>
        <Divider light />
        {content}

        <Box
          className={classes.tableBox}
          display="flex"
          justifyContent="space-between"
        >
          <Button
            className={classes.buttons}
            onClick={handleBack}
            color="primary"
            variant="outlined"
            disabled={loading}
            type="button"
          >
            {t('COMMON.BACK')}
          </Button>
          <Button
            className={clsx(classes.buttons, classes.buttonMain)}
            type={data.sendToDigitalSign ? 'button' : 'submit'}
            onClick={() => data.sendToDigitalSign && setOpenConfirmation(true)}
            color="primary"
            variant="outlined"
            disabled={loading}
          >
            {t('COMMON.CREATE')}
          </Button>
        </Box>
        <ContractConfirmationDialog
          open={openConfirmation}
          handleClose={() => setOpenConfirmation(false)}
          handleSubmit={handleSubmit}
          isFirstRentWithInitialPayment={data.gracePeriod < 0}
        />
      </form>
    </FadeIn>
  );
};
FinalStep.propTypes = {
  data: PropTypes.object.isRequired,
  includeEquipmentStep: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

FinalStep.defaultProps = {
  includeEquipmentStep: false
};

export default FinalStep;
